package org.example.project.firebase

data class GitHubUserInfo(
    val username: String,
    val photoUrl: String
)

expect object GitHubAuth {
    suspend fun login(): GitHubUserInfo?
}
